export default "__VITE_ASSET__avsSV4QV__"